export default "__VITE_ASSET__C4nnAAkR__"